import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudSnowing02 = function CloudSnowing02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8 18h.01M8 21h.01M12 18.5h.01m-.01 3h.01M16 18h.01M16 21h.01M7 15c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5q.0497 0 .0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A5 5 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15z"
    })
  }));
};
export default CloudSnowing02;